module.exports = __webpack_public_path__ + "img/reactNative.77419cfe.jpg";